"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvenCardAccountHolderType = void 0;
// Keep these sorted, from top prio to lowest.  A person should be represented by the highest priority type that correctly describes them
var AvenCardAccountHolderType;
(function (AvenCardAccountHolderType) {
    AvenCardAccountHolderType["PRIMARY"] = "PRIMARY";
    /** A person who is a Co-Applicant has this type, even if they are also a Co-Owner. */
    AvenCardAccountHolderType["CO_APPLICANT"] = "CO_APPLICANT";
    /** CO_OWNER type is a Co-Owner who is NOT a Co-Applicant.  Not all co_owners become Aven Card Account Holders.  But those who do should have this type. */
    AvenCardAccountHolderType["CO_OWNER"] = "CO_OWNER";
    AvenCardAccountHolderType["AUTHORIZED_USER"] = "AUTHORIZED_USER";
})(AvenCardAccountHolderType || (exports.AvenCardAccountHolderType = AvenCardAccountHolderType = {}));
